import { render, staticRenderFns } from "./GoogleSignin.vue?vue&type=template&id=5f55527a&scoped=true&"
import script from "./GoogleSignin.vue?vue&type=script&lang=js&"
export * from "./GoogleSignin.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSignin.vue?vue&type=style&index=0&id=5f55527a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55527a",
  null
  
)

export default component.exports